import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { SprayCrudService } from 'src/app/shared/services/spray-crud.service';
import { Spray } from 'src/app/shared/interfaces/spray';

@Component({
  selector: 'app-sprays',
  templateUrl: './sprays.component.html',
  styleUrls: ['./sprays.component.scss']
})
export class SpraysComponent implements OnInit {

  
  sprays: Spray[];
  spray: Spray;
  selectedSprays: Spray[] = [];

  sprayDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private sprayService : SprayCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Sprays'}
    ];

    this.sprays = [];
    this.spray = { } as Spray ;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.sprayService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.sprays = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Spray = jsonItem as Spray;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.sprays.push(l);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.sprayService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.sprays);
            doc.save('sprays.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.sprays);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "sprays");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedSprays);
      // console.log('SAVEC CSV LOCATIONS ', this.sprays);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedSprays, 'sprays', exportCols);
   // this.exportService.exportToCsv(this.sprays, 'sprays', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.spray = {} as Spray;
    this.submitted = false;
    this.sprayDialog = true;
  }

  deleteSelectedSprays() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected sprays?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.sprays = this.sprays.filter(val => !this.selectedSprays.includes(val));
            
            this.selectedSprays.forEach( spray => this.sprayService.delete(spray.$key));
            this.selectedSprays = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Sprayss Deleted', life: 3000});
        }
    });
  }

  editSpray(spray: Spray) {
    this.spray = {...spray};
    this.sprayDialog = true;
  }

  deleteSpray(spray: Spray) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + spray.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.sprays = this.sprays.filter(val => val.$key !== spray.$key);
            this.spray = {} as Spray;
            this.sprayService.delete(spray.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Spray Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.sprayDialog = false;
    this.submitted = false;
  }

  saveSpray() {
    this.submitted = true;

    if ( this.spray.name.trim() ) {
      this.spray.isEnabled = true;
      
      if (this.spray.$key) {
          this.sprays[this.findIndexById(this.spray.$key)] = this.spray;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Spray Updated', life: 3000});
          this.sprayService.update(this.spray);
        } else {
          this.spray.position = this.sprays.length;
          this.sprayService.add(this.spray);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Spray Created', life: 3000});
      this.sprays = [...this.sprays];
    }

    this.sprayDialog = false;
    this.spray = { } as Spray;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.sprays.length; i++) {
        if (this.sprays[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeSpray(spray : Spray) {
    //console.log("SAVE", spray);
    this.sprayService.update(spray);
  }

  completePosition(spray : Spray) {
   // console.log("SAVE", spray);
  //  this.sprayService.updateSpray(spray);


    if ( this.newPosition > -1 ) {
        spray.position = this.newPosition;
        spray = this.checkPositionLimits(spray);
        this.reorderElements(spray);
        //this.updateDB(spray);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.sprays);
    // const myClonedArray = [];
    // this.sprays.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.sprays.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.sprays.length - 1 - event.dropIndex;
    const sprayToMove = this.sprays[startIndex];
    
    
    // console.log('StartIndex', startIndex);
    // console.log('EndIndex', endIndex);

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.sprays[index] = this.sprays[index+1];
        this.sprays[index].position = index;
        this.sprayService.update(this.sprays[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.sprays[index] = this.sprays[index-1];
        this.sprays[index].position = index;
        this.sprayService.update(this.sprays[index]);
      }
    } 
    this.sprays[endIndex] = sprayToMove;
    this.sprays[endIndex].position = endIndex;
    this.sprayService.update(this.sprays[endIndex]);
  }

  // onFieldEdit(spray: Spray, fieldName: string): void {
  //   //console.log(this.sprays);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + spray[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       spray.position = this.newPosition;
  //       spray = this.checkPositionLimits(spray);
  //       this.reorderElements(spray);
  //       //this.updateDB(spray);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(spray);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.sprays.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, spray: Spray) {
    // console.log("event" +event);
    if (spray.position != null && spray.position > -1) {
      this.previousPosition = spray.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(spray: Spray) {
    console.log('check ',spray.position + ' ' + this.sprays.length);
    if (!spray.position) {
     // console.log('check 1');
      return this.spray;
    }
    if (spray.position < 0) {
      spray.position = 0;
      // console.log('check 2');
      return spray;
    }
    if (spray.position > this.sprays.length) {
      spray.position = this.sprays.length - 1;
    //  console.log('check 3', spray.position);
      return spray;
    }
   // console.log('check 4');
    return spray;
  }

  async reorderElements(spray: Spray) {
    this.newPosition = this.newPosition  > this.sprays.length ? this.sprays.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === spray.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const sprayToMove = this.sprays[startIndex];
   // console.log('Item to move: ', this.sprays[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.sprays);
        console.log('Item to +1: ', this.sprays[index+1]);

        this.sprays[index] = this.sprays[index+1];
        this.sprays[index].position = index;
        // console.log('Move: ', this.sprays[index+1]);
        // console.log('Move pos: ', this.sprays[index].position);
        //await this.updateDB(this.sprays[index]);
        this.sprayService.update(this.sprays[index]);
     //   console.log('Update DB: ', this.sprays[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.sprays[index] = this.sprays[index-1];
        this.sprays[index].position = index;
        this.sprayService.update(this.sprays[index]);
      }
    } 
    this.sprays[endIndex] = sprayToMove;
    this.sprays[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.sprayService.update(this.sprays[endIndex]);
    
    // const myClonedArray = [];
    // this.sprays.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.sprays = myClonedArray;
   // this.getAllRecords();
  }
}
